import axios from 'axios';
import httpClient from '@common/api/httpClient';
import { type IntegrationResponse } from '@common/types/api';
import { type InstallationId } from '@common/types/brandedTypes';

export async function fetchInstallationIntegrations(
  installationId: InstallationId,
  signal: AbortSignal,
) {
  try {
    const { data } = await httpClient.get<IntegrationResponse[]>(
      `/rest/v1/Integrations/Installation/${installationId}`,
      { signal },
    );
    return data;
  } catch (err: unknown) {
    // The request is aborted on every unmount, so cancellation is routine. Anything else means
    // the list could not be loaded, and the empty list we fall back to is indistinguishable from
    // "this installation has no integrations" - so say so. Reaching here at all implies the
    // installation itself already loaded, so even an auth failure is a genuine anomaly.
    if (!axios.isCancel(err)) {
      console.error(
        `Failed to load integrations for installation ${installationId}`,
        err,
      );
    }

    return [];
  }
}
